// @ts-nocheck
import React, { useState } from 'react';
import ActionBar from '../layout/ActionBar';
import RequestKeys from './slideout/RequestKeys';
import { userIs } from '../auth/authUtils';
import userTypes from '../../constants/userTypes';
import SlidingPane from 'react-sliding-pane';
import RequestsTable from './components/RequestsTable';
import Button from '../common/Button';
import { useTranslation } from 'react-i18next';
import { usePageTitle } from '../../util/pageTitle';
import { useAppSelector } from '../../hooks';

export interface RequestsAssignedToMeProps {
  setCompleteRequestSlideoutOpen: (open: boolean) => void;
}

function RequestsAssignedToMe({ setCompleteRequestSlideoutOpen }: RequestsAssignedToMeProps) {
  usePageTitle(['Assigned to me', 'Requests']);
  const currentUser = useAppSelector((state) => state.auth);
  const { t } = useTranslation();

  const [reload, setReload] = useState<Date | undefined>();
  const [requestKeysSlideoutOpen, setRequestKeysSlideoutOpen] = useState(false);
  const [breadcrumb, setBreadcrumb] = useState([
    { label: t('Requests'), link: '/requests/assigned-to-me' },
  ]);

  return (
    <>
      <ActionBar>
        {userIs(currentUser, userTypes.REQUESTER) && (
          <Button
            className="btn btn-primary ms-2"
            onClick={() => setRequestKeysSlideoutOpen(true)}
            text={t('Request keys')}
          />
        )}
      </ActionBar>

      <RequestsTable
        assignedToMe={true}
        groupedStorageKey="requestsGrouped-assigned-to-me"
        setCompleteRequestSlideoutOpen={setCompleteRequestSlideoutOpen}
        scope={{ assignedToMe: currentUser?.id }}
        reload={reload}
        setReload={setReload}
        settingsKey="assignedtome-requests-list"
      />

      <SlidingPane
        isOpen={requestKeysSlideoutOpen}
        hideHeader={true}
        from="right"
        className="small-side-panel"
        onRequestClose={() => setRequestKeysSlideoutOpen(false)}
      >
        <RequestKeys
          done={() => {
            setRequestKeysSlideoutOpen(false);
            setCompleteRequestSlideoutOpen(true);
            setReload(new Date());
          }}
          cancel={() => setRequestKeysSlideoutOpen(false)}
        />
      </SlidingPane>
    </>
  );
}

export default RequestsAssignedToMe;
